import { render, staticRenderFns } from "./address-card.tests.vue?vue&type=template&id=f98729ec&scoped=true"
import script from "./address-card.tests.vue?vue&type=script&lang=ts"
export * from "./address-card.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98729ec",
  null
  
)

export default component.exports